import { DialogTitle, DialogTitleProps } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';
import { ModalFullPageRenderCallbackArgs } from './ModalFullPage.component';
import React from 'react';


export type ModalFullPageTitleProps = ModalFullPageRenderCallbackArgs & DialogTitleProps;


const _ModalFullPageTitle: React.FC<ModalFullPageTitleProps> = ({ displayMobileOnlyStyles: _displayMobileOnlyStyles, ...props }) => (
  <DialogTitle {...props} />
);

export const ModalFullPageTitle = withStyles(_ModalFullPageTitle, (_theme, props) => ({
  root: (() => {
    if (props.displayMobileOnlyStyles) {
      return {
        boxShadow: `inset 0 -1px 0 ${grey[300]}`
      };
    }

    return {};
  })(),
}), { name: 'ModalFullPageTitle' });

